import { render, staticRenderFns } from "./LightSet.vue?vue&type=template&id=10ce94cd&scoped=true"
import script from "./LightSet.vue?vue&type=script&lang=js"
export * from "./LightSet.vue?vue&type=script&lang=js"
import style0 from "./LightSet.vue?vue&type=style&index=0&id=10ce94cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ce94cd",
  null
  
)

export default component.exports